<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    group: crmGroup,
    disabled: !hasWawBackOffice
  }"
></ng-container>
<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    group: rebootstrapLicensesGroup,
    disabled: !hasWawBackOffice
  }"
>
</ng-container>

<ng-template
  #template
  let-group="group"
  let-customTemplate="customTemplate"
  let-disabled="disabled"
>
  <form [formGroup]="group">
    <h5 class="header">{{ group?.get('header')?.value }}</h5>
    <div class="row unique-identifiers">
      <div class="section" formArrayName="actionButtons">
        <div
          class="section__actionButton"
          *ngFor="let action of group?.get('actionButtons')?.controls"
        >
          <span
            [ngbTooltip]="
              disabled
                ? 'Requires the Waw role & meeting the prerequisites from the description to the right'
                : ''
            "
          >
            <button
              [ngClass]="action?.get('class')?.value"
              [disabled]="action?.get('isDisabled')?.value || disabled"
              (click)="action?.get('click')?.value()"
            >
              <span>{{ action?.get('title')?.value }}</span>
            </button>
          </span>
          <span
            *ngIf="action?.get('actionOK')?.get('enabled')?.value"
            class="section__actionButton--validation-msg"
          >
            {{ action?.get('actionOK')?.get('text')?.value }}
          </span>
          <span
            *ngIf="action?.get('actionFAIL')?.get('enabled')?.value"
            class="section__actionButton--validation-msg"
          >
            {{ action?.get('actionFAIL')?.get('text')?.value }}
          </span>
        </div>
      </div>
      <div class="section">
        <ng-container *ngIf="customTemplate; else defaultTemplate">
          <ng-container
            [ngTemplateOutlet]="customTemplate"
            [ngTemplateOutletContext]="{
              group: group?.get('data')?.get('custom')
            }"
          >
          </ng-container>
        </ng-container>
        <ng-template #defaultTemplate>
          <ng-container
            *ngFor="
              let description of group
                ?.get('data')
                ?.get('default')
                ?.get('descriptions')?.value
            "
          >
            <span>{{ description }}</span>
            <br />
          </ng-container>
        </ng-template>
      </div>
    </div>
  </form>
</ng-template>
